<template>
  <div class="box">

    <div class="columns">

      <div class="column is-two-thirds">

        <!-- the new post title -->
        <div class="field">
          <label class="label">Post's title</label>
          <div class="control">
            <input type="text" class="input" placeholder="Title" v-model="post.title">
          </div>
        </div>

        <!-- rich text vue-quill-editor plugin -->
        <quill-editor v-model="post.content_html" :options="editorOptions" />
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">

      </div>

      <!-- new post right sidebar -->
      <div class="column is-one-third">

        <div class="field">
          <label class="label">Audio</label>
          <div class="control">
            <audio controls v-if="post.attachments[0].url">
              <source :src="post.attachments[0].url" type="audio/mp4">
              Your browser does not support the audio element.
            </audio>
            <div class="file">
              <label class="file-label">
                <input @change="uploadAudio" class="file-input" type="file" accept=".m4a" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose an audio file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">Featured image</label>
          <div class="control">
            <img :src="post.image">
            <div class="file">
              <label class="file-label">
                <input @change="uploadImage" class="file-input" type="file" accept=".jpg" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- notification -->
    <div v-if="notification.message" :class="'notification is-' + notification.type">
      <button class="delete" @click="hideNotifications"></button>{{notification.message}}
    </div>

    <!-- the form buttons -->
    <button type="submit" class="button is-success" @click="add('published')">Publish</button>
    <button type="submit" class="button is-info" @click="add('saved')">Save Draft</button>
    <router-link to="/admin/posts" class="button is-danger">Cancel</router-link>
  </div>
</template>

<script>
import firebase from 'firebase'

import { mediaRef } from '@/firebase_config'
import editorOptions from './editor-options-complete'
import imageLoader from '@/mixins/image-loader'
import notifier from '@/mixins/notifier'

export default {
  name: 'post-new',
  data () {
    return {
      body: '',
      author: '',
      tags: [],
      inputData: '',
      featuredImage: '',
      category: '',
      editorOptions,
      post: {
        status: 'draft',
        date_modified: Date.now(),
        date_published: Date.now(),
        id: '',
        title: '',
        content_text: '',
        content_html: '',
        image: '',
        attachments: [
          {
            url: '',
            duration_in_seconds: 0,
            mime_type: 'audio/x-m4a',
            size_in_bytes: [0]
          }
        ],
        _itunes: {
          explicit: false,
          image: ''
        }
      }
    }
  },
  firebase: {
    media: mediaRef
  },
  props: ['add-episode'],
  mixins: [imageLoader, notifier],
  methods: {
    uuidv4 () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    add (state) {
      if (this.post.title) {
        this.post.id = this.uuidv4()
        let tmp = document.createElement('div')
        tmp.innerHTML = this.post.content_html.replace(/<\/p>/g, '</p>\n')
        this.post.content_text = tmp.textContent || tmp.innerText || ''
        this.post.attachments[0].url = this.post.attachments[0].url.replace('https://', 'https://dts.podtrac.com/redirect.m4a/')
        this.addEpisode(this.post)
        this.$router.push({ path: '/admin/posts' })
      } else {
        this.showNotification('warning', 'The title field can not be empty')
      }
    },
    uploadAudio (e) {
      console.log(e)
      let file = e.target.files[0]
      var storageRef = firebase.app().storage('gs://neolivros-public').ref('/' + file.name)
      var self = this
      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        // self.post.attachments[0].url = snapshot.downloadURL
        self.post.attachments[0].url = 'https://storage.googleapis.com/neolivros-public/' + snapshot.metadata.fullPath
        self.post.attachments[0].mime_type = snapshot.metadata.contentType
        self.post.attachments[0].size_in_bytes[0] = snapshot.metadata.size

        var au = document.createElement('audio')
        au.src = self.post.attachments[0].url
        au.addEventListener('loadedmetadata', function () {
          // Obtain the duration in seconds of the audio file (with milliseconds as well, a float value)
          self.post.attachments[0].duration_in_seconds = parseInt(au.duration)
          console.log('The duration of the song is of: ' + self.post.attachments[0].duration + ' seconds')
        }, false)

        console.log(self.post.attachments[0].url)
      })
    },
    uploadImage (e) {
      console.log(e)
      let file = e.target.files[0]
      var storageRef = firebase.app().storage('gs://neolivros-public').ref('/' + file.name)
      var self = this
      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        // self.post.attachments[0].url = snapshot.downloadURL
        self.post.image = 'https://storage.googleapis.com/neolivros-public/' + snapshot.metadata.fullPath
        self.post._itunes.image = 'https://storage.googleapis.com/neolivros-public/' + snapshot.metadata.fullPath
        console.log(self.post.image)
      })
    },
    uploadFeaturedImage (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('images/' + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.featuredImage = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    styleTags () {
      if (this.inputData !== '') {
        this.tags.push(`${this.inputData.trim()}`)
        this.inputData = ''
      }
    },
    removeTag (index) {
      this.tags.splice(index, 1)
    }
  }
}

</script>

<style>
.tagscontainer {
  border: 2px solid #f2f2f2;
  border-radius: 5px;
  padding: 5px;
}
.pointer {
  cursor: pointer;
}
.ql-editor{
    min-height:100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/PostNew.vue